import { StoryFacade } from 'utils/facades/story-facade';
import { STORY_EDITOR_SYNC } from 'admin/constants/actions';
import { updateLatestStory } from 'admin/actions/story/update-latest-story';
import { updateStory } from 'admin/actions/story/update-story';
import { flushStoryEditorSave } from 'admin/actions/story/flush-story-editor-save';
import { isEditOperationsSave } from 'admin/utils/story-save-mechanism';

export function storyEditorSync() {
	return async (dispatch, getState) => {
		if (isEditOperationsSave) {
			// Edit operations are the only save path, and their saver reports the save status.
			await dispatch(flushStoryEditorSave());
			return;
		}

		dispatch({ type: STORY_EDITOR_SYNC.SYNC });

		let error;

		try {
			const {
				storyEditor: { story },
				version: { current: version },
			} = getState();

			// Persist the committed story, which edit operations are captured from; the story form is
			// only an editing buffer (Story Settings) whose values are committed on submit.
			// FIXME: update main row only if needed and latest ver also, not always you need to update both of them
			const Story = new StoryFacade(story, version);
			await Promise.all([
				// update story main row (not versioned)
				dispatch(updateStory(Story.requestMainRowData, { getStoryOnComplete: false })),
				// update story data for certain version
				dispatch(updateLatestStory({ ...Story.requestData, getStoryOnComplete: false })),
			]);
		} catch (err) {
			error = err;
			dispatch({ type: STORY_EDITOR_SYNC.FAIL, payload: err });
			console.error(err);
		}

		if (!error) {
			dispatch({ type: STORY_EDITOR_SYNC.SUCCESS });
		}
	};
}
